import { Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { useStopDeployment } from '@/queries/deploymentQueries'
import { DeploymentGroup, DeploymentGroupMember } from '@/types/deploymentGroup'
import { GroupConfirmModal } from './GroupConfirmModal'
import { getMemberCameraName } from './deploymentTreeHelpers'
import { DeploymentTreeGroupContext } from './deploymentTreeTypes'
import { useRunDeploymentAction } from './useRunDeploymentAction'

type MemberPauseConfirmProps = {
  opened: boolean
  member: DeploymentGroupMember
  group: DeploymentGroup
  context: DeploymentTreeGroupContext
  onClose: () => void
}

export const MemberPauseConfirm = ({
  opened,
  member,
  group,
  context,
  onClose
}: MemberPauseConfirmProps) => {
  const { mutateAsync: stopDeployment, isPending } = useStopDeployment()
  const run = useRunDeploymentAction(onClose)

  const remaining = group.members.length - 1

  const handleConfirm = () =>
    void run(() => stopDeployment(member.deployment_id), {
      inProgress: 'deployments.groups.member.pause.inProgress',
      error: 'deployments.groups.member.pause.error'
    })

  return (
    <GroupConfirmModal
      opened={opened}
      title={<FormattedMessage id="deployments.groups.member.pause.title" />}
      confirmLabel={
        <FormattedMessage id="deployments.groups.member.pause.title" />
      }
      isPending={isPending}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <Text size="sm">
        <FormattedMessage
          id={
            remaining > 0
              ? 'deployments.groups.member.pause.confirmation'
              : 'deployments.groups.member.pause.lastMember'
          }
          values={{
            camera: getMemberCameraName(member, context.device),
            number: context.label,
            count: remaining
          }}
        />
      </Text>
    </GroupConfirmModal>
  )
}
